import type { Mention } from '../../hooks';
import type { CommentMention } from '../../containers/CommentList/CommentList.types';

export function toCommentMentions(mentions: Mention[]): CommentMention[] {
  const commentMentions = mentions.map(m => ({
    uid: m.user.username,
    email: m.user.email,
    fullName: m.user.name
  }));

  // Deduplicate by uid
  return dedupeCommentMentions(commentMentions);
}

/**
 * Deduplicates CommentMention array by uid
 * Keeps the first occurrence of each unique uid
 */
export function dedupeCommentMentions(
  mentions: CommentMention[]
): CommentMention[] {
  const seen = new Set<string>();
  return mentions.filter(mention => {
    if (seen.has(mention.uid)) {
      return false;
    }
    seen.add(mention.uid);
    return true;
  });
}
